import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { LoginContext } from '../../../context/LoginContext';
import { useNavigate, useParams } from 'react-router-dom';
import { SiPayloadcms } from 'react-icons/si';

const PhonePePayment = () => {

  const { isLoggedIn, userId, userData } = useContext(LoginContext);
  const [paymentData, setPaymentData] = useState([]);
  const [activePlan, setActivePlan] = useState([]);
  const param = useParams();
  const navigate = useNavigate();


  useEffect(() => {

    if (!isLoggedIn) {
      navigate("/login");
    }

    const fetchPaymentStatus = async () => {
      const payload = new FormData();
      payload.append("user_id", userId);
      payload.append("looking", userData.looking_for);
      payload.append("gender", userData.gender);
      payload.append("status", userData.status);
      payload.append("email", userData.email);

      axios.post(`${process.env.REACT_APP_API_PAYMENT_URL}user/checkallpayments`, payload)
        .then(response => {
          setPaymentData(response.data);
          const currentDate = new Date();
          setActivePlan(response.data.filter(item => item.status === "COMPLETED" && new Date(item.valid_upto) > currentDate));
        })
        .catch(error => {
          console.error("There was an error fetching data in header!", error);
        });
    };

    if (param.id) {
      fetchPaymentStatus();
    }
  }, [param.id]);



  return (
    <div>

      <div class="container py-5">
        <div class="row justify-content-center">

          {activePlan.map((res) => (

            <div className="col-md-4 my-3">
              <div className="card mx-auto pricing-card shadow-sm p-3">
                <div className="card-body d-flex " style={{ flexDirection: "column" }}>
                  <span className="badge bg-warning text-dark mb-2 mx-auto">Most Popular Plan</span>
                  <h5 className="card-title text-center">Premium</h5>

                  <table className='table table-bordered'>
                    <tbody>
                      <tr>
                        <td> <p className='fw-bold mb-0 fs-4'><span className="fw-bold fs-4">₹ {res.amount/100} </span>/- Annually</p> </td>
                      </tr>
                    </tbody>
                  </table>
                  <p className="card-subtitle mb-3 text-muted text-center" style={{ color: "#A16304" }}>Valid From : {res.valid_from.substring(0,10)}</p>

                  <button className="btn btn-danger w-100 mb-3" >
                    Valid Upto: {res.valid_upto.substring(0,10)}
                  </button>


                </div>
              </div>
            </div>

          ))}



          <div class="col-12">
            <div class="card " style={{ overflowX: "auto" }}>
              <table class="table table-bordered table-responsive">
                <thead className='table-head'>
                  <tr>
                    <th>Date</th>
                    <th>Order Id</th>
                    <th>Payment Mode</th>
                    <th>Amount</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>


                  {paymentData?.map((res) =>

                  (<tr class="overdue-row">
                    <td>{res.created_at.substring(0, 10)}</td>
                    <td>{res.order_id}</td>
                    <td>{(res.other)?res.other:"Cancelled"}</td>
                    <td>₹ {res.amount / 100} </td>
                    <td>
                      {(res.status == "FAILED" || res.status==null) &&
                        (<p class="bg-danger text-white p-1 rounded-2 text-center  ">Failed</p>)}
                      {(res.status == "COMPLETED") &&
                        (<p class="bg-success text-white p-1 rounded-2 text-center  ">Success</p>)}
                    </td>
                  </tr>

                  ))}


                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>


    </div>
  );
};

export default PhonePePayment;
